import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Checkbox,
  FormLayout,
  PageActions,
  Toast,
  Text,
  Spinner,
  Loading,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
const SectionsCustomization = () => {
  const [isLoading, setIsLoading] = useState(true);
  const loadingMarkup = isLoading ? <Loading /> : null;
  const [item, setItem] = useState({
    checkedDashboard: true,
    checkedPages: true,
    checkedUi: true,
    checkedBlogs: true,
    checkedNavigation: true,
    checkedCrm: true,
    checkedRichtext: true,
    checkedBanner: true,
    checkedImageWithText: true,
    checkedList: true,
    checkedVideo: true,
    checkedCode: true,
    checkedIframe: true,
    checkedShopifyCollection: true,
    checkedCountdown: true,
    checkedPopup: true,
    checkedNavigationSection: true,
    checkedObject: true,
    checkedCustomBlock: true,
  });
  const handleChangeCheckedDashboard = (newValue) => {
    setItem({ ...item, checkedDashboard: newValue });
  };
  const handleChangeCustomBlock = (newValue) => {
    setItem({ ...item, checkedCustomBlock: newValue });
  };
  const handleChangeCheckedNavigationSection = (newValue) => {
    setItem({ ...item, checkedNavigationSection: newValue });
  };
  const handleChangeCheckedPages = (newValue) => {
    setItem({ ...item, checkedPages: newValue });
  };
  const handleChangeCheckedUi = (newValue) => {
    setItem({ ...item, checkedUi: newValue });
  };
  const handleChangeCheckedBlogs = (newValue) => {
    setItem({ ...item, checkedBlogs: newValue });
  };
  const handleChangeCheckedCrm = (newValue) => {
    setItem({ ...item, checkedCrm: newValue });
  };
  const handleChangeCheckedNavigation = (newValue) => {
    setItem({ ...item, checkedNavigation: newValue });
  };

  const handleChangeCheckedRichtext = (newValue) => {
    setItem({ ...item, checkedRichtext: newValue });
  };
  const handleChangeCheckedBanner = (newValue) => {
    setItem({ ...item, checkedBanner: newValue });
  };
  const handleChangeCheckedObject = (newValue) => {
    setItem({ ...item, checkedObject: newValue });
  };
  const handleChangeCheckedImageWithText = (newValue) => {
    setItem({ ...item, checkedImageWithText: newValue });
  };
  const handleChangeCheckedList = (newValue) => {
    setItem({ ...item, checkedList: newValue });
  };
  const handleChangeCheckedVideo = (newValue) => {
    setItem({ ...item, checkedVideo: newValue });
  };
  const handleChangeCheckedCode = (newValue) => {
    setItem({ ...item, checkedCode: newValue });
  };
  const handleChangeCheckedIframe = (newValue) => {
    setItem({ ...item, checkedIframe: newValue });
  };
  const handleChangeCheckedCountdown = (newValue) => {
    setItem({ ...item, checkedCountdown: newValue });
  };
  const handleChangeCheckedPopup = (newValue) => {
    setItem({ ...item, checkedPopup: newValue });
  };
  const handleSelectChangeCheckedShopifyCollection = (newValue) => {
    setItem({ ...item, checkedShopifyCollection: newValue });
  };
  const [isSaving, setIsSaving] = useState(false);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  useEffect(() => {
    axios
      .get(`/settings/display-content`)
      .then((result) => {
        setIsSaving(false);

        result?.data?.data.length &&
          setItem({
            checkedDashboard:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.dashboard)
                ? true
                : false,
            checkedCrm:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.crm)
                ? true
                : false,
            checkedPages:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.pages)
                ? true
                : false,
            checkedUi:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.ui_text)
                ? true
                : false,
            checkedNavigation:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.navigation)
                ? true
                : false,
            chedkCrm:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.crm)
                ? true
                : false,
            checkedBlogs:
              result?.data?.data[1] &&
              result?.data?.data[1].main_menu &&
              parseInt(result?.data?.data[1].main_menu?.blogs)
                ? true
                : false,

            checkedRichtext:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.richtext)
                ? true
                : false,
            checkedObject:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.object)
                ? true
                : false,
            checkedNavigationSection:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.navigation)
                ? true
                : false,
            checkedImageWithText:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.image)
                ? true
                : false,
            checkedList:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.list)
                ? true
                : false,
            checkedVideo:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.video)
                ? true
                : false,
            checkedCode:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.code)
                ? true
                : false,
            checkedIframe:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.iframe)
                ? true
                : false,
            checkedShopifyCollection:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.shopify_collection)
                ? true
                : false,
            checkedBanner:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.banner)
                ? true
                : false,
            checkedCountdown:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.countdown)
                ? true
                : false,
            checkedPopup:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.popup)
                ? true
                : false,
            checkedCustomBlock:
              result?.data?.data[0] &&
              result?.data?.data[0].section &&
              parseInt(result?.data?.data[0].section?.custom_block)
                ? true
                : false,
          });
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Page title="Sections Customization" narrowWidth>
      <Card sectioned>
        {isLoading ? (
          <div className="spinnerContainer">
            <div className="vertical-center">
              <Spinner size="large" />
            </div>
          </div>
        ) : (
          <FormLayout.Group>
            <FormLayout>
              <Text variant="headingXs" as="h6">
                MAIN MENU
              </Text>
              <Checkbox
                label="Dashboard"
                checked={item.checkedDashboard}
                onChange={handleChangeCheckedDashboard}
              />
              <Checkbox
                label="Pages"
                checked={item.checkedPages}
                onChange={handleChangeCheckedPages}
              />
              <Checkbox
                label="UI Text"
                checked={item.checkedUi}
                onChange={handleChangeCheckedUi}
              />
              <Checkbox
                label="Blogs"
                checked={item.checkedBlogs}
                onChange={handleChangeCheckedBlogs}
              />
              <Checkbox
                label="Navigation"
                checked={item.checkedNavigation}
                onChange={handleChangeCheckedNavigation}
              />
              <Checkbox
                label="CRM"
                checked={item.checkedCrm}
                onChange={handleChangeCheckedCrm}
              />
            </FormLayout>

            <FormLayout>
              <Text variant="headingXs" as="h6">
                SECTIONS TYPES
              </Text>
              <Checkbox
                label="Rich Text"
                checked={item.checkedRichtext}
                onChange={handleChangeCheckedRichtext}
              />
              <Checkbox
                label="Banner"
                checked={item.checkedBanner}
                onChange={handleChangeCheckedBanner}
              />
              <Checkbox
                label="Image with text"
                checked={item.checkedImageWithText}
                onChange={handleChangeCheckedImageWithText}
              />
              <Checkbox
                label="List"
                checked={item.checkedList}
                onChange={handleChangeCheckedList}
              />
              <Checkbox
                label="Video"
                checked={item.checkedVideo}
                onChange={handleChangeCheckedVideo}
              />
              <Checkbox
                label="Code"
                checked={item.checkedCode}
                onChange={handleChangeCheckedCode}
              />
              <Checkbox
                label="Iframe"
                checked={item.checkedIframe}
                onChange={handleChangeCheckedIframe}
              />
              <Checkbox
                label="Shopify Collection"
                checked={item.checkedShopifyCollection}
                onChange={handleSelectChangeCheckedShopifyCollection}
              />
              <Checkbox
                label="Countdown"
                checked={item.checkedCountdown}
                onChange={handleChangeCheckedCountdown}
              />
              <Checkbox
                label="Popup"
                checked={item.checkedPopup}
                onChange={handleChangeCheckedPopup}
              />
              <Checkbox
                label="Navigation"
                checked={item.checkedNavigationSection}
                onChange={handleChangeCheckedNavigationSection}
              />
              <Checkbox
                label="Object"
                checked={item.checkedObject}
                onChange={handleChangeCheckedObject}
              />
              <Checkbox
                label="Custom Block"
                checked={item.checkedCustomBlock}
                onChange={handleChangeCustomBlock}
              />
            </FormLayout>
          </FormLayout.Group>
        )}
        {/* <Card.Section title="MAIN MENU">
          <FormLayout>
            <Checkbox
              label="Dashboard"
              checked={item.checkedDashboard}
              onChange={handleChangeCheckedDashboard}
            />
            <Checkbox
              label="Pages"
              checked={item.checkedPages}
              onChange={handleChangeCheckedPages}
            />
            <Checkbox
              label="UI Text"
              checked={item.checkedUi}
              onChange={handleChangeCheckedUi}
            />
            <Checkbox
              label="Blogs"
              checked={item.checkedBlogs}
              onChange={handleChangeCheckedBlogs}
            />
            <Checkbox
              label="Navigation"
              checked={item.checkedNavigation}
              onChange={handleChangeCheckedNavigation}
            />
            <Checkbox
              label="CRM"
              checked={item.checkedCrm}
              onChange={handleChangeCheckedCrm}
            />
          </FormLayout>
        </Card.Section>

        <Card.Section title="SECTIONS TYPES">
          <FormLayout>
            <Checkbox
              label="Rich Text"
              checked={item.checkedRichtext}
              onChange={handleChangeCheckedRichtext}
            />
            <Checkbox
              label="Banner"
              checked={item.checkedBanner}
              onChange={handleChangeCheckedBanner}
            />
            <Checkbox
              label="Image with text"
              checked={item.checkedImageWithText}
              onChange={handleChangeCheckedImageWithText}
            />
            <Checkbox
              label="List"
              checked={item.checkedList}
              onChange={handleChangeCheckedList}
            />
            <Checkbox
              label="Video"
              checked={item.checkedVideo}
              onChange={handleChangeCheckedVideo}
            />
            <Checkbox
              label="Code"
              checked={item.checkedCode}
              onChange={handleChangeCheckedCode}
            />
            <Checkbox
              label="Shopify Collection"
              checked={item.checkedShopifyCollection}
              onChange={handleSelectChangeCheckedShopifyCollection}
            />
          </FormLayout>
        </Card.Section> */}
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("main_menu[dashboard]", item.checkedDashboard ? 1 : 0);
    form_data.append(
      "main_menu[custom block]",
      item.checkedCustomBlock ? 1 : 0
    );
    form_data.append("main_menu[crm]", item.checkedCrm ? 1 : 0);
    form_data.append("main_menu[pages]", item.checkedPages ? 1 : 0);
    form_data.append("main_menu[ui_text]", item.checkedUi ? 1 : 0);
    form_data.append("main_menu[blogs]", item.checkedBlogs ? 1 : 0);
    form_data.append("main_menu[navigation]", item.checkedNavigation ? 1 : 0);
    form_data.append("section[richtext]", item.checkedRichtext ? 1 : 0);
    form_data.append("section[banner]", item.checkedBanner ? 1 : 0);
    form_data.append("section[image]", item.checkedImageWithText ? 1 : 0);
    form_data.append("section[list]", item.checkedList ? 1 : 0);
    form_data.append("section[code]", item.checkedCode ? 1 : 0);
    form_data.append("section[iframe]", item.checkedIframe ? 1 : 0);
    form_data.append("section[video]", item.checkedVideo ? 1 : 0);
    form_data.append("section[countdown]", item.checkedCountdown ? 1 : 0);
    form_data.append("section[popup]", item.checkedPopup ? 1 : 0);
    form_data.append("section[object]", item.checkedObject ? 1 : 0);

    form_data.append(
      "section[shopify_collection]",
      item.checkedShopifyCollection ? 1 : 0
    );
    form_data.append(
      "section[navigation]",
      item.checkedNavigationSection ? 1 : 0
    );
    form_data.append("section[custom_block]", item.checkedCustomBlock ? 1 : 0);

    axios
      .post(`/settings/display-content`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
        window.location.reload(false);
      })
      .catch((err) => console.log(""));
  }
};

export default SectionsCustomization;
